/**
 * Stable deep-links into the documentation.
 *
 * Use these when linking to docs from elsewhere in the app (help buttons,
 * empty states, error panels) so the destinations survive slug changes —
 * update the target here in one place if a page moves.
 */
export const DOCS_LINKS = {
  DOCS_HOME: "/docs",
  FORMAT_GUIDE: "/docs/format-guide/overview",
  QUERY_LANGUAGE: "/docs/query-language/overview",
  RECODE: "/docs/format-guide/recode",
  CALC_CAT: "/docs/query-language/calc-and-cat",
} as const
